import { use } from "react";
import { AccentColorContext, type AccentColorContextValue } from "./AccentColorProvider";

export function useAccentColor(): AccentColorContextValue {
  const context = use(AccentColorContext);
  if (!context) {
    throw new Error("useAccentColor must be used within an AccentColorProvider");
  }
  return context;
}
